const sanitizeReactHookFormRegisterOptions = (options: any) => {
    if (!options) return {};

    // remove onchange and onblur from options
    const { onChange, onBlur, ...rest } = options;
    return rest;
};

export default sanitizeReactHookFormRegisterOptions;
